var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "card-box", attrs: { "body-style": { padding: 0 } } },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("span", [_vm._v(_vm._s(_vm.deviceCode))])]
          )
        ]
      ),
      _vm._v(" "),
      _c("el-card", { staticClass: "card-box" }, [
        _c(
          "div",
          {
            staticClass: "card-header",
            attrs: { slot: "header" },
            slot: "header"
          },
          [_c("span", [_vm._v("游客模式")])]
        ),
        _vm._v(" "),
        _c("span", [_vm._v("程序由前端写死，不获取后台配置")])
      ]),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "card-box" },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _c("span", [_vm._v("新用户(注册未使用)")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "el-icon-plus",
                    color: "#fff",
                    title: "配置",
                    size: "mini"
                  },
                  on: { click: _vm.onClickAddNew }
                },
                [_vm._v("配置")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              attrs: {
                id: "newListTable",
                data: _vm.newList,
                border: "",
                stripe: "",
                "highlight-current-row": ""
              }
            },
            [
              _c(
                "el-table-column",
                { attrs: { align: "center", label: "排序", width: "80" } },
                [
                  _c("div", { staticClass: "handle" }, [
                    _c("i", { staticClass: "el-icon-sort" })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "80" }
              }),
              _vm._v(" "),
              _vm._l(_vm.tableColumn, function(item, index) {
                return [
                  _c("el-table-column", {
                    key: index,
                    attrs: {
                      label: item.label,
                      formatter: item.formatter,
                      prop: item.prop
                    }
                  })
                ]
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              title: "编辑",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.updateNewItem(scope.row)
                              }
                            }
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              title: "删除",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.delNewItem(scope.row)
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "card-box" },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _c("span", [_vm._v("旧用户(有使用记录)")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "el-icon-plus",
                    color: "#fff",
                    title: "配置",
                    size: "mini"
                  },
                  on: { click: _vm.onClickAddOld }
                },
                [_vm._v("配置")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            { attrs: { "label-position": "left" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "推送程序套数", required: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { type: "number", placeholder: "请输入推送套数" },
                    on: { blur: _vm.onPushCountBlur },
                    model: {
                      value: _vm.pushCount,
                      callback: function($$v) {
                        _vm.pushCount = $$v
                      },
                      expression: "pushCount"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              attrs: {
                id: "oldListTable",
                data: _vm.oldList,
                border: "",
                stripe: "",
                "highlight-current-row": ""
              }
            },
            [
              _c(
                "el-table-column",
                { attrs: { align: "center", label: "排序", width: "80" } },
                [_c("i", { staticClass: "el-icon-sort handle" })]
              ),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "80" }
              }),
              _vm._v(" "),
              _vm._l(_vm.tableColumn, function(item, index) {
                return [
                  _c("el-table-column", {
                    key: index,
                    attrs: {
                      label: item.label,
                      formatter: item.formatter,
                      prop: item.prop
                    }
                  })
                ]
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              title: "编辑",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.updateOldItem(scope.row)
                              }
                            }
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              title: "删除",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.delOldItem(scope.row)
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "card-box" },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _c("span", [_vm._v("选择补充程序")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "el-icon-plus",
                    color: "#fff",
                    title: "配置",
                    size: "mini"
                  },
                  on: {
                    click: function($event) {
                      _vm.showSupply = true
                    }
                  }
                },
                [_vm._v("配置")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              attrs: {
                id: "supplyListTable",
                data: _vm.supplyList,
                border: "",
                stripe: "",
                "highlight-current-row": ""
              }
            },
            [
              _c(
                "el-table-column",
                { attrs: { align: "center", label: "排序", width: "80" } },
                [_c("i", { staticClass: "el-icon-sort handle" })]
              ),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "80" }
              }),
              _vm._v(" "),
              _vm._l(_vm.supplyTableColumn, function(item, index) {
                return [
                  _c("el-table-column", {
                    key: index,
                    attrs: {
                      label: item.label,
                      formatter: item.formatter,
                      prop: item.prop
                    }
                  })
                ]
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              title: "编辑",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.updateSupplyItem(scope.row)
                              }
                            }
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              title: "删除",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.delSupplyItem(scope.row)
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showNew,
            width: "800",
            title: "新用户配置",
            closeable: "",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.showNew = $event
            },
            close: function($event) {
              return _vm.onDialogClose("new")
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "newForm",
              attrs: {
                model: _vm.newForm,
                "label-width": "120",
                rules: _vm.newFormRule,
                "label-position": "top"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "推荐规则", required: "", prop: "reason" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.newForm.reason,
                        callback: function($$v) {
                          _vm.$set(_vm.newForm, "reason", $$v)
                        },
                        expression: "newForm.reason"
                      }
                    },
                    _vm._l(_vm.newReasonList, function(item, index) {
                      return _c(
                        "el-radio",
                        { key: index, attrs: { label: item.code, border: "" } },
                        [_vm._v(_vm._s(item.label))]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              parseInt(_vm.newForm.reason) == 2
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "程序名称",
                        required: "",
                        prop: "programId"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择程序" },
                          model: {
                            value: _vm.newForm.programId,
                            callback: function($$v) {
                              _vm.$set(_vm.newForm, "programId", $$v)
                            },
                            expression: "newForm.programId"
                          }
                        },
                        _vm._l(_vm.programList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "原因介绍", prop: "description" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入原因介绍(非必填)" },
                    model: {
                      value: _vm.newForm.description,
                      callback: function($$v) {
                        _vm.$set(_vm.newForm, "description", $$v)
                      },
                      expression: "newForm.description"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              parseInt(_vm.newForm.reason) == 1
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "conditions" } },
                    [
                      _c(
                        "label",
                        { attrs: { slot: "label" }, slot: "label" },
                        [
                          _c("span", [_vm._v("推荐条件")]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "z-index": "100" },
                              attrs: {
                                type: "primary",
                                icon: "el-icon-plus",
                                size: "mini"
                              },
                              on: {
                                click: function() {
                                  ;(_vm.showCondition = true),
                                    (_vm.conditionType = "new")
                                }
                              }
                            },
                            [_vm._v("添加")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.newForm.conditions,
                            border: "",
                            stripe: "",
                            "highlight-current-row": ""
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { type: "index", label: "序号", width: "80" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "程序名称" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.programName(scope.row))
                                        )
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2513620890
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "性别" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.conditionGender(scope.row.sex)
                                          )
                                        )
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              876520485
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "类型" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.conditionTypeName(
                                              scope.row.conditions
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2028019179
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "推荐条件" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.conditionTermName(
                                              scope.row.conditions
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3717218685
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "操作", width: "100" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "danger",
                                            title: "删除",
                                            size: "mini"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.delNewConditionItem(
                                                scope.row
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("删除")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              620527846
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticStyle: { "text-align": "center" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "50%" },
                      attrs: { disabled: _vm.disableNew, type: "primary" },
                      on: { click: _vm.onSaveNewConfig }
                    },
                    [_vm._v("保存")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showOld,
            width: "800",
            title: "推送程序添加",
            "close-on-click-modal": false,
            closeable: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.showOld = $event
            },
            close: function($event) {
              return _vm.onDialogClose("old")
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "oldForm",
              attrs: {
                model: _vm.oldForm,
                rules: _vm.oldFormRule,
                "label-width": "120",
                "label-position": "top"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "推荐原因", required: "", prop: "reason" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择原因" },
                      model: {
                        value: _vm.oldForm.reason,
                        callback: function($$v) {
                          _vm.$set(_vm.oldForm, "reason", $$v)
                        },
                        expression: "oldForm.reason"
                      }
                    },
                    _vm._l(_vm.oldReasonList, function(item, index) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: { label: item.label, value: item.code }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "tips" }, [
                _vm._v(
                  "提示规则：如果碰到推荐重复，去重；推荐原因优先级：招牌套餐＞猜你喜欢＞我的喜爱＞我最常用＞最多人选择＞检测结果推荐＞全新升级"
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "程序名称", required: "", prop: "programId" }
                },
                [
                  _vm.oldForm.reason
                    ? [
                        _vm.oldForm.reason == 1 || _vm.oldForm.reason == 2
                          ? _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "请选择程序" },
                                model: {
                                  value: _vm.oldForm.programId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.oldForm, "programId", $$v)
                                  },
                                  expression: "oldForm.programId"
                                }
                              },
                              _vm._l(_vm.programList, function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.name, value: item.id }
                                })
                              }),
                              1
                            )
                          : _c("span", { staticClass: "ljtj" }, [
                              _vm._v("逻辑推荐")
                            ])
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "原因介绍", prop: "description" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入原因介绍" },
                    model: {
                      value: _vm.oldForm.description,
                      callback: function($$v) {
                        _vm.$set(_vm.oldForm, "description", $$v)
                      },
                      expression: "oldForm.description"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.oldForm.reason == 3
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "conditionList" } },
                    [
                      _c(
                        "label",
                        { attrs: { slot: "label" }, slot: "label" },
                        [
                          _c("span", [_vm._v("推荐条件")]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "z-index": "100" },
                              attrs: {
                                type: "primary",
                                icon: "el-icon-plus",
                                size: "mini"
                              },
                              on: {
                                click: function() {
                                  ;(_vm.showCondition = true),
                                    (_vm.conditionType = "old")
                                }
                              }
                            },
                            [_vm._v("添加")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.oldForm.conditions,
                            border: "",
                            stripe: "",
                            "highlight-current-row": ""
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { type: "index", label: "序号", width: "80" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "程序名称" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.programName(scope.row))
                                        )
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2513620890
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "性别" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.conditionGender(scope.row.sex)
                                          )
                                        )
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              876520485
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "类型" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.conditionTypeName(
                                              scope.row.conditions
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2028019179
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "推荐条件" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.conditionTermName(
                                              scope.row.conditions
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3717218685
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "操作", width: "100" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "danger",
                                            title: "删除",
                                            size: "mini"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.delOldConditionItem(
                                                scope.row
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("删除")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3211383261
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticStyle: { "text-align": "center" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "50%" },
                      attrs: { disabled: _vm.disableOld, type: "primary" },
                      on: { click: _vm.onSaveOldConfig }
                    },
                    [_vm._v("保存")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showCondition,
            width: "500",
            title: "添加推荐条件",
            "close-on-click-modal": false,
            closeable: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.showCondition = $event
            },
            close: function($event) {
              return _vm.onDialogClose("condition")
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "conditionForm",
              attrs: {
                model: _vm.conditionForm,
                rules: _vm.conditionFormRule,
                "label-width": "120"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: "程序名称", required: "", prop: "programId" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择程序" },
                      model: {
                        value: _vm.conditionForm.programId,
                        callback: function($$v) {
                          _vm.$set(_vm.conditionForm, "programId", $$v)
                        },
                        expression: "conditionForm.programId"
                      }
                    },
                    _vm._l(_vm.programList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "选择性别", prop: "gender", required: "" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.conditionForm.gender,
                        callback: function($$v) {
                          _vm.$set(_vm.conditionForm, "gender", $$v)
                        },
                        expression: "conditionForm.gender"
                      }
                    },
                    [
                      _c("el-checkbox", { attrs: { label: "1", value: "1" } }, [
                        _vm._v("男")
                      ]),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "0", value: "0" } }, [
                        _vm._v("女")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "推荐类别", prop: "type", required: "" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.conditionForm.type,
                        callback: function($$v) {
                          _vm.$set(_vm.conditionForm, "type", $$v)
                        },
                        expression: "conditionForm.type"
                      }
                    },
                    _vm._l(_vm.conditionsList, function(item, index) {
                      return _c(
                        "el-checkbox-button",
                        { key: item.code, attrs: { label: item.code } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.hasAge
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "年龄",
                        prop: "typeValue",
                        required: "",
                        "label-width": "120"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "condition-line" },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "flex-1",
                              model: {
                                value: _vm.conditionForm.typeRadio,
                                callback: function($$v) {
                                  _vm.$set(_vm.conditionForm, "typeRadio", $$v)
                                },
                                expression: "conditionForm.typeRadio"
                              }
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  staticClass: "line-radio",
                                  attrs: { label: "1" }
                                },
                                [_vm._v("大于等于")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio",
                                {
                                  staticClass: "line-radio",
                                  attrs: { label: "2" }
                                },
                                [_vm._v("大于")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio",
                                {
                                  staticClass: "line-radio",
                                  attrs: { label: "3" }
                                },
                                [_vm._v("小于等于")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio",
                                {
                                  staticClass: "line-radio",
                                  attrs: { label: "4" }
                                },
                                [_vm._v("小于")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex-1" },
                            [
                              _vm.conditionForm.typeRadio
                                ? _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入限制年龄(岁,必填)"
                                    },
                                    model: {
                                      value: _vm.conditionForm.typeValue,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.conditionForm,
                                          "typeValue",
                                          $$v
                                        )
                                      },
                                      expression: "conditionForm.typeValue"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasHeight
                ? _c(
                    "el-form-item",
                    {
                      attrs: { label: "身高", prop: "typeValue", required: "" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "condition-line" },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "flex-1",
                              model: {
                                value: _vm.conditionForm.typeRadio,
                                callback: function($$v) {
                                  _vm.$set(_vm.conditionForm, "typeRadio", $$v)
                                },
                                expression: "conditionForm.typeRadio"
                              }
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  staticClass: "line-radio",
                                  attrs: { label: "1" }
                                },
                                [_vm._v("大于等于")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio",
                                {
                                  staticClass: "line-radio",
                                  attrs: { label: "2" }
                                },
                                [_vm._v("大于")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio",
                                {
                                  staticClass: "line-radio",
                                  attrs: { label: "3" }
                                },
                                [_vm._v("小于等于")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio",
                                {
                                  staticClass: "line-radio",
                                  attrs: { label: "4" }
                                },
                                [_vm._v("小于")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex-1" },
                            [
                              _vm.conditionForm.typeRadio
                                ? _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入限制身高(CM,必填)"
                                    },
                                    model: {
                                      value: _vm.conditionForm.typeValue,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.conditionForm,
                                          "typeValue",
                                          $$v
                                        )
                                      },
                                      expression: "conditionForm.typeValue"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasWeight
                ? _c(
                    "el-form-item",
                    {
                      attrs: { label: "体重", prop: "typeValue", required: "" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "condition-line" },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "flex-1",
                              model: {
                                value: _vm.conditionForm.typeRadio,
                                callback: function($$v) {
                                  _vm.$set(_vm.conditionForm, "typeRadio", $$v)
                                },
                                expression: "conditionForm.typeRadio"
                              }
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  staticClass: "line-radio",
                                  attrs: { label: "1" }
                                },
                                [_vm._v("大于等于")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio",
                                {
                                  staticClass: "line-radio",
                                  attrs: { label: "2" }
                                },
                                [_vm._v("大于")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio",
                                {
                                  staticClass: "line-radio",
                                  attrs: { label: "3" }
                                },
                                [_vm._v("小于等于")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio",
                                {
                                  staticClass: "line-radio",
                                  attrs: { label: "4" }
                                },
                                [_vm._v("小于")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex-1" },
                            [
                              _vm.conditionForm.typeRadio
                                ? _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入限制体重(KG,必填)"
                                    },
                                    model: {
                                      value: _vm.conditionForm.typeValue,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.conditionForm,
                                          "typeValue",
                                          $$v
                                        )
                                      },
                                      expression: "conditionForm.typeValue"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasBMI
                ? _c(
                    "el-form-item",
                    { attrs: { label: "BMI", prop: "bmi", required: "" } },
                    [
                      _c(
                        "div",
                        { staticClass: "condition-line" },
                        [
                          _c("el-input", {
                            staticClass: "flex-1",
                            attrs: { placeholder: "BMI最小值" },
                            on: {
                              change: function($event) {
                                return _vm.onBMIChange($event, "min")
                              }
                            },
                            model: {
                              value: _vm.bmiMin,
                              callback: function($$v) {
                                _vm.bmiMin = $$v
                              },
                              expression: "bmiMin"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticStyle: { margin: "0 10px" } }, [
                            _vm._v("＜ BMI ＜")
                          ]),
                          _vm._v(" "),
                          _c("el-input", {
                            staticClass: "flex-1",
                            attrs: { placeholder: "BMI最大值" },
                            on: {
                              change: function($event) {
                                return _vm.onBMIChange($event, "max")
                              }
                            },
                            model: {
                              value: _vm.bmiMax,
                              callback: function($$v) {
                                _vm.bmiMax = $$v
                              },
                              expression: "bmiMax"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "tips" }, [
                        _vm._v(
                          "提示：低于18.5kg/m²，为体重过低；高于23.9kg/m²，为超重或肥胖。"
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticStyle: { "text-align": "center" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "50%" },
                      attrs: {
                        disabled: _vm.disableCondition,
                        type: "primary"
                      },
                      on: { click: _vm.onSaveCondition }
                    },
                    [_vm._v("保存")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSupply,
            width: "500",
            title: "选择补充程序",
            "close-on-click-modal": false,
            closeable: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.showSupply = $event
            },
            close: function($event) {
              return _vm.onDialogClose("supply")
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "supplyForm",
              attrs: {
                model: _vm.supplyForm,
                rules: _vm.supplyFormRule,
                "label-width": "120"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: "程序名称", required: "", prop: "programId" }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择程序" },
                      model: {
                        value: _vm.supplyForm.programId,
                        callback: function($$v) {
                          _vm.$set(_vm.supplyForm, "programId", $$v)
                        },
                        expression: "supplyForm.programId"
                      }
                    },
                    _vm._l(_vm.programList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "原因介绍", prop: "description" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入原因介绍" },
                    model: {
                      value: _vm.supplyForm.description,
                      callback: function($$v) {
                        _vm.$set(_vm.supplyForm, "description", $$v)
                      },
                      expression: "supplyForm.description"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticStyle: { "text-align": "center" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "50%" },
                      attrs: { disabled: _vm.disableSupply, type: "primary" },
                      on: { click: _vm.onSaveSupplyConfig }
                    },
                    [_vm._v("保存")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }